import React from 'react';
import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from 'components/Button';
import { TYPE } from 'theme';
import CloseIcon from '@mui/icons-material/Close';
import { ModalStyles } from 'theme/commonStyles';

const Wrapper = styled(Dialog)`
    .MuiBackdrop-root {
        backdrop-filter: blur(20px);
    }
    .MuiDialog-paper {
        ${ModalStyles}
        background-color: #000;
        min-width: 340px;
        padding: 0px 20px 30px 20px;
        box-sizing: border-box;
        border-radius: 16px;
        position: relative;
        ${({ theme }) => theme.mediaWidth.upToSmall`
            min-width: unset;
            padding: 0;
            margin: 0;
        `}
        box-shadow: 0px 10px 63px 2px rgba(61, 37, 14, 0.41), 0px 45px 110px 14px rgba(96, 50, 112, 0.45);
    }
`;

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const CloseButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    cursor: pointer;
    z-index: 1;
    border-radius: 12px;
    &:hover {
        opacity: 0.8;
    }
`;

const StyledCloseIcon = styled(CloseIcon)`
    width: 24px;
    height: 24px;
    color: #fff;
`;

const StyledDialogActions = styled(DialogActions)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    button {
        padding-left: 40px;
        padding-right: 40px;
    }
`;

const StyledDialogContent = styled(DialogContent)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export interface ResultDialogProps {
    open: boolean;
    type: 'success' | 'error';
    title: string;
    text?: string;
    onClose?: () => void;
    confirmText?: string;
    hideClose?: boolean;
    content?: React.ReactNode;
}

export function ResultDialog({
    open,
    title,
    content,
    onClose,
    confirmText = 'OK',
    hideClose = false,
}: ResultDialogProps) {
    return (
        <Wrapper open={open} onClose={onClose}>
            <TitleWrapper>
                <DialogTitle>
                    <TYPE.main fontSize={20} fontWeight={600} textAlign="center">
                        {title}
                    </TYPE.main>
                </DialogTitle>
                {!hideClose && (
                    <CloseButton onClick={onClose}>
                        <StyledCloseIcon />
                    </CloseButton>
                )}
            </TitleWrapper>
            <StyledDialogContent>{content}</StyledDialogContent>
            <StyledDialogActions>
                <Button
                    onClick={onClose}
                    size="middle"
                    type="gradient"
                    style={{ height: '40px', width: '100%', borderRadius: '40px' }}
                >
                    {confirmText}
                </Button>
            </StyledDialogActions>
        </Wrapper>
    );
}
